import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const LanguageListContainer = styled.div`
  position: absolute;
  left: ${1060 * Screen.widthRatio}px;
  top: ${524 * Screen.widthRatio}px;
  width: ${150 * Screen.widthRatio}px;
`;

export default LanguageListContainer;
